// Pfad einer Messe-Kachel. Die Slugs sind redaktionell gepflegt, darum wird das
// Ziel aus event.tiles gelesen statt geraten — fehlt die Kachel, gibt es kein
// Ziel und die Stelle bleibt unverlinkt (#53).
export const tilePath = (event, type) => {
    const tile = event.tiles.find(t => type === t.type)
    return tile ? `/events/${event.slug}/${tile.slug}/` : null
}
